import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

const authService = {
  async login(username, password) {
    const resp = await fetch(`${GO_BACKEND_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    if (!resp.ok) {
      let msg = `HTTP error! status: ${resp.status}`;
      try {
        const data = await resp.json();
        if (data && data.error) msg = data.error;
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await resp.json();
    if (!data || !data.token) {
      throw new Error("Missing token in response");
    }

    return data.token;
  },
};

export default authService;
